// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3iURr","inner":"Footer_inner__3O8BM","nextIcon":"Footer_nextIcon__1yBGv","innerLeft":"Footer_innerLeft__1893L"};